"use client";

import { LocalStorageKeys, getLocalStorage, setLocalStorage } from "@/app/_utilities/localStorage";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const SaveUTMs = () => {
  const searchParams = useSearchParams();
  useEffect(() => {
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmCampaign = searchParams.get("utm_campaign");
    const utmContent = searchParams.get("utm_content");
    const utmTerm = searchParams.get("utm_term");
    const gclid = searchParams.get("gclid");

    if (utmSource || utmMedium || utmCampaign || utmContent || utmTerm || gclid) {
      // if any of the utms are set, update them all
      setLocalStorage(LocalStorageKeys.UTM_SOURCE, utmSource || "");
      setLocalStorage(LocalStorageKeys.UTM_MEDIUM, utmMedium || "");
      setLocalStorage(LocalStorageKeys.UTM_CAMPAIGN, utmCampaign || "");
      setLocalStorage(LocalStorageKeys.UTM_CONTENT, utmContent || "");
      setLocalStorage(LocalStorageKeys.UTM_TERM, utmTerm || "");
      setLocalStorage(LocalStorageKeys.GCLID, gclid || "");
    }
  }, [searchParams]);

  return <></>;
};

export const getUTMs = () => {
  return {
    utmSource: getLocalStorage(LocalStorageKeys.UTM_SOURCE) || "",
    utmMedium: getLocalStorage(LocalStorageKeys.UTM_MEDIUM) || "",
    utmCampaign: getLocalStorage(LocalStorageKeys.UTM_CAMPAIGN) || "",
    utmContent: getLocalStorage(LocalStorageKeys.UTM_CONTENT) || "",
    utmTerm: getLocalStorage(LocalStorageKeys.UTM_TERM) || "",
    gclid: getLocalStorage(LocalStorageKeys.GCLID) || "",
  };
};
